<template>
  <div>
    <!-- Add Dispatch Modal -->
    <AddDispatch
      v-if="addDispatch"
      :show="addDispatch"
      v-on:closeGroupModal="addDispatch = false"
      @customer_details="customer_details"
      :payload="customerDetails"
    />

    <!--  New Item Modal Empty -->
    <ModalWrapper :show="addNewEmpty" :showBtn="false">
      <div class="wrapper">
        <h4 class="">{{ $t("addNewItemTitle") }}</h4>
        <p class="">{{ $t("addMultipleItemsDelivery") }}</p>
        <button
          type="button"
          @click="handleSubmit"
          class="btn btn-primary mt-3"
        >
          {{ $t("addNewItemButton") }}
        </button>
        <button
          type="button"
          @click="
            () => {
              this.addNewEmpty = false;
              this.addDispatch = true;
            }
          "
          class="btn-absolute btn-secondary btn"
        >
          {{ $t("backButton") }}
        </button>
      </div>
    </ModalWrapper>

    <!--  Added Items Modal -->
    <ModalWrapper :show="openAddedItems" :showBtn="false">
      <div class="added_items">
        <h5 class="">{{ $t("customerDetails") }}</h5>
        <div class="d-flex align-items-center justify-content-between mb-3">
          <p class="mb-0">{{ $t("addMultipleItemsDelivery") }}</p>
          <button
            type="button"
            @click="
              openAddNewItem = true;
              openAddedItems = false;
            "
            class=" btn-primary btn btn-white"
          >
            {{ $t("addNewItemButton") }}
          </button>
        </div>
        <div v-for="(item, i) in savedItems" :key="i" class="position-relative">
          <div
            @click="handleDropdown(i)"
            style="font-size:1rem; width:fit-content"
            class="ml-auto cursor-pointer"
          >
            &#x2022;&#x2022;&#x2022;
          </div>
          <div class="edit-drop" v-show="i === showDropdown">
            <span @click="openEdit(item, i)">
              {{ $t("editItem") }}
            </span>
            <span @click="doDeleteItem(i)">
              {{ $t("removeItem") }}
            </span>
          </div>
          <div class="row items py-2">
            <div class="col-sm-4 col-6 mb-0">
              <div class="row">
                <div class="col-6 mb-3">
                  <p class="font-weight-bold font-16">{{ $t("name") }}</p>
                </div>
                <div class="col-6">
                  <p>{{ item.item }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-6 mb-3">
                  <p class="font-weight-bold font-16">{{ $t("quantity") }}</p>
                </div>
                <div class="col-6">
                  <p>{{ item.quantity }}</p>
                </div>
              </div>
            </div>

            <div class="col-sm-4 col-6 mb-0">
              <div class="row">
                <div class="col-6 mb-3">
                  <p class="font-weight-bold font-16">{{ $t("weight") }}</p>
                </div>
                <div class="col-6">
                  <p>{{ item.weight }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-6 mb-3">
                  <p class="font-weight-bold font-16">{{ $t("devices") }}</p>
                </div>
                <div class="col-6">
                  <p>{{ item.devices.length }}</p>
                </div>
              </div>
            </div>

            <div class="col-sm-4 col-6 mb-0">
              <div class="row">
                <div class="col-7 mb-3">
                  <p class="font-weight-bold font-16">{{ $t("price") }}</p>
                </div>
                <div class="col-5">
                  <p>{{ item.price }}</p>
                </div>
              </div>

              <div class="row">
                <div class=" mb-2">
                  <p class="font-weight-bold font-16">
                    {{ $t("description") }}
                  </p>
                </div>
                <div class="">
                  <p>{{ item.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          @click="
            openSummary = true;
            openAddedItems = false;
          "
          class="btn btn-primary mt-4 float-right"
        >
          {{ $t("nextButton") }}
        </button>
      </div>
    </ModalWrapper>

    <!-- Add New Item Modal -->
    <ModalWrapper
      :show="openAddNewItem"
      :showBtn="true"
      :header="$t('newItemHeader')"
      :submitText="$t('saveButton')"
      :doSubmit="'submit_new_item'"
      @submit_new_item="submitNewItem"
      @close_new_item="closeNewItem"
      :doCancel="'close_new_item'"
      :cancelText="$t('backButton')"
      :disabled="addNewItem.devices.length < 1"
    >
      <div class="form-group">
        <label>{{ $t("whatDelivering") }}</label>
        <input
          type="text"
          v-model="addNewItem.item"
          name="description"
          class="form-control"
          required
        />
      </div>

      <div class="d-flex col-gap-1">
        <div class="form-group w-100">
          <label>{{ $t("itemQuantity") }}</label>
          <input
            type="number"
            v-model="addNewItem.quantity"
            name="quantity"
            class="form-control"
            required
          />
        </div>
        <div class="form-group w-100">
          <label> {{ $t("itemPrice") }} (&#8358;)</label>
          <input
            type="number"
            v-model="addNewItem.price"
            name="price"
            class="form-control"
            required
          />
        </div>
      </div>
      <div class="d-flex col-gap-1">
        <div class="form-group w-100">
          <label>{{ $t("itemDescription") }}</label>
          <input
            type="text"
            name="quantity"
            v-model="addNewItem.description"
            class="form-control"
            required
          />
        </div>
        <div class="form-group w-100">
          <label>{{ $t("itemWeight") }}</label>
          <input
            type="number"
            v-model="addNewItem.weight"
            name="price"
            class="form-control"
            step=".1"
          />
        </div>
      </div>
      <div class="device">
        <div
          class="form-control view-selected"
          @click="showDevice = !showDevice"
        >
          <span>{{
            addNewItem.devices.length > 1
              ? `${addNewItem.devices.length} ${$t("devicesSelected")}`
              : $t("selectDevicePlaceholder")
          }}</span>
          <span class="col-gap-1 align-items-center d-flex">
            <em
              class="fas fa-solid fa-angle-up fa-lg position-relative"
              style="top:3px"
              v-if="showDevice"
            ></em>
            <em
              v-else
              class="fas fa-solid fa-angle-down fa-lg position-relative"
              style="top:3px"
            ></em>
          </span>
        </div>
        <div class="emails py-2" v-show="showDevice">
          <input
            type="text"
            v-model="searchKey"
            @input="doSearch"
            class="search-input mb-3 w-100"
            autofocus
            :placeholder="$t('searchDevicesPlaceholder')"
          />
          <div class="devices_">
            <div
              class="check-devices d-flex mb-2 pl-2 align-items-center"
              v-for="(device, i) in filteredDevices"
              :key="i"
            >
              <input
                type="checkbox"
                @click="updateDevice(device.imei)"
                :checked="addNewItem.devices.includes(device.imei)"
                :id="device._id"
                style="cursor:pointer"
              />
              <label
                :for="device._id"
                class=" gray4 mb-0 font-16 cursor-pointer"
                style="margin-left: 0.7rem;font-weight: 100;"
              >
                {{ device.settings.name }}</label
              >
            </div>
          </div>
        </div>
      </div>
    </ModalWrapper>

    <!--  Added Items Modal -->
    <ModalWrapper
      :show="openSummary"
      :showBtn="true"
      :header="$t('summaryKey')"
      :submitText="$t('generateTrackingCodeKey')"
      :cancelText="$t('backKey')"
      :doSubmit="'submit_summary'"
      @submit_summary="submitSummary"
      :doCancel="'back_summary'"
      @back_summary="backSummay"
    >
      <div class="summary">
        <section class="section-1 pb-2">
          <h5 class="">{{ $t("customerDetailsKey") }}</h5>
          <div class="row col-12 mb-2">
            <div class="col-4 pl-0">
              <p class="gray4">{{ $t("nameKey") }}</p>
            </div>
            <div class="col">
              <p class="gray4">{{ customerDetails.name }}</p>
            </div>
          </div>
          <div class="row col-12 mb-2">
            <div class="col-4 pl-0">
              <p class="gray4">{{ $t("addressKey") }}</p>
            </div>
            <div class="col">
              <p class="gray4">{{ customerDetails.address }}</p>
            </div>
          </div>
          <div class="row col-12 mb-2">
            <div class="col-4 pl-0">
              <p class="gray4">{{ $t("emailKey") }}</p>
            </div>
            <div class="col">
              <p class="gray4">{{ customerDetails.email }}</p>
            </div>
          </div>
          <div class="row col-12 mb-2">
            <div class="col-4 pl-0">
              <p class="gray4">{{ $t("phoneKey") }}</p>
            </div>
            <div class="col">
              <p class="gray4">{{ customerDetails.phone }}</p>
            </div>
          </div>
          <div class="row col-12 mb-2">
            <div class="col-4 pl-0">
              <p class="gray4">{{ $t("descriptionKey") }}</p>
            </div>
            <div class="col">
              <p class="gray4">{{ customerDetails.description }}</p>
            </div>
          </div>
        </section>
        <section class="section-2 mt-3 pb-2">
          <h5 class="mb-3">{{ $t("itemDetailsKey") }}</h5>

          <div
            class="item col-12"
            :class="i !== savedItems.lengtth && 'mb-3'"
            v-for="(item, i) in savedItems"
            :key="i"
          >
            <div class="row col-6 mb-0">
              <div class="col-4 pl-0">
                <p>{{ $t("nameKey") }}</p>
              </div>
              <div class="col-8">
                <p class="gray4 overflow-auto">{{ item.item }}</p>
              </div>
              <div class="col-4 pl-0">
                <p>{{ $t("quantityKey") }}</p>
              </div>
              <div class="col-8">
                <p class="gray4">{{ item.quantity }}</p>
              </div>
              <div class="col-4 pl-0  mb-0">
                <p>{{ $t("priceKey") }}</p>
              </div>
              <div class="col-8">
                <p class="gray4">{{ item.price }}</p>
              </div>
            </div>

            <div class="row col-6  mb-0">
              <div class="col-4 pl-0">
                <p>{{ $t("weightKey") }}</p>
              </div>
              <div class="col-8">
                <p class="gray4">{{ item.weight }}</p>
              </div>
              <div class="col-4 pl-0">
                <p>{{ $t("deviceNoKey") }}</p>
              </div>
              <div class="col-8">
                <p class="gray4">{{ item.devices.length }}</p>
              </div>
              <div class="pl-0  mb-0">
                <p>{{ $t("descriptionKey") }}</p>
              </div>
              <div class="">
                <p class="gray4 overflow-auto">{{ item.description }}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </ModalWrapper>

    <!-- Tracking Code -->
    <ModalWrapper :show="openTrack" :showBtn="false">
      <p
        class="cursor-pointer float-right"
        @click="
          openTrack = false;
          trackingCode = '';
        "
      >
        <img src="../../assets/images/Vector (1).png" alt="" />
      </p>
      <div class="tracking-code">
        <h5 class="mb-5" style="color: #5E6A79">{{ $t("trackingCode") }}</h5>
        <h1 class="font-weight-bold">{{ trackingCode }}</h1>
        <p class="mb-0 gray4">{{ $t("codeSentTo") }}</p>
      </div>
    </ModalWrapper>

    <div class="page-wrapper">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="bars"
      ></loading>
      <div class="page-breadcrumb">
        <div class="row">
          <div class="col-lg-5 align-self-center">
            <h6 class="page-title">{{ $t("all_dispatch") }}</h6>
          </div>
          <div class="col-lg-7 align-self-center">
            <div class="d-flex align-items-center justify-content-end">
              <button
                @click="addDispatch = true"
                class="btn btn-primary"
                style="color:white"
              >
                {{ $t("new_group") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div style="padding-left:20px">
        <h5>
          <span class="text-primary">{{ $t("trackerLink") }}</span>
          <a
            :href="link"
            target="_blank"
            rel="noopener noreferrer"
            class="gray4"
          >
            {{ link }}
          </a>
        </h5>
      </div>
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <DispatchTable :stats="dispatchRecords" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer text-center">
        &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
      </footer>
      <!-- ============================================================== -->
      <!-- End footer -->
      <!-- ============================================================== -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import AddDispatch from "../Modals/AddDispatch.vue";
import ModalWrapper from "../Modals/ModalWrapper.vue";
import DispatchTable from "../../components/DispatchTable.vue";

export default {
  name: "Dispatch",
  data() {
    return {
      group_name: "",
      group_description: "",
      minTemp: "",
      maxTemp: "",
      minHumi: "",
      maxHumi: "",
      mssg: "",
      tempmssg: "",
      humimssg: "",
      Errormssg: "",
      isOpen: false,
      isLoading: true,
      fullPage: true,
      activegroups: [],
      addDispatch: false,
      addNewEmpty: false,
      openAddedItems: false,
      openAddNewItem: false,
      openSummary: false,
      customerDetails: {},
      addNewItem: {
        item: "",
        quantity: null,
        price: null,
        description: "",
        weight: null,
        devices: [],
      },
      savedItems: [],
      showDevice: false,
      openTrack: false,
      trackingCode: "",
      showDropdown: null,
      edit: {
        isEdit: false,
        index: null,
      },
      searchKey: "",
      filteredDevices: [],
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mounted() {
    this.fetchallDevices();
    this.getBusinessProfile();
    this.getDispatchRecords()
      .then(() => {
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        this.Errormssg =
          error.response.data.message[0].toUpperCase() +
          error.response.data.message.slice(1);
        // error.response can be null
        if (error.response) {
          console.error(error.response.data.message);
        }
      });
    this.filteredDevices = this.devices;
  },
  components: {
    Loading,
    AddDispatch,
    ModalWrapper,
    DispatchTable,
  },
  watch: {
    groups: {
      handler: function() {
        this.initialiseGroups();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["dispatchRecords", "devices", "businessprofile"]),
    link() {
      return `https://track.figorr.com/${this.businessprofile.uniqueCode}`;
    },
  },
  methods: {
    ...mapActions([
      "getDispatchRecords",
      "fetchallDevices",
      "createDispatch",
      "getBusinessProfile",
    ]),
    handleSubmit() {
      this.addNewEmpty = false;
      this.openAddNewItem = true;
    },
    submitNewItem() {
      this.openAddNewItem = false;
      this.openAddedItems = true;
      if (this.edit.isEdit) {
        let temp = [...this.savedItems];
        temp.splice(this.edit.index, 1, this.addNewItem);
        this.savedItems = temp;
      } else {
        this.savedItems = [...this.savedItems, this.addNewItem];
      }
      this.addNewItem = {
        item: "",
        quantity: null,
        price: null,
        description: "",
        weight: null,
        devices: [],
      };
      this.edit = {
        isEdit: false,
        index: null,
      };
    },
    doSearch() {
      const filtered = this.devices.filter(({ settings: { name } }) =>
        name.toLowerCase().includes(this.searchKey.toLowerCase())
      );
      this.filteredDevices = filtered;
    },
    closeNewItem() {
      this.openAddNewItem = false;
      this.addNewEmpty = true;
    },
    customer_details(payload) {
      this.customerDetails = payload;
      this.addDispatch = false;
      this.addNewEmpty = true;
    },
    submitSummary() {
      const payload = {
        ...this.customerDetails,
        items: this.savedItems,
      };
      this.isLoading = true;
      this.createDispatch(payload).then((res) => {
        this.getDispatchRecords();
        this.isLoading = false;
        this.openSummary = false;
        this.openTrack = true;
        this.trackingCode = res.data.data.trackingId;
        this.customerDetails = {};
        this.savedItems = [];
      });
    },
    backSummay() {
      this.openSummary = false;
      this.openAddedItems = true;
    },
    updateDevice(id) {
      let temp = [...this.addNewItem.devices];
      let index = temp.indexOf(id);
      if (index >= 0) {
        temp.splice(index, 1);
      } else {
        temp.push(id);
      }
      this.addNewItem.devices = temp;
    },
    openEdit(editItem, i) {
      const { item, price, description, quantity, weight, devices } = editItem;
      this.addNewItem = {
        item,
        quantity,
        price,
        description,
        weight,
        devices,
      };
      this.openAddNewItem = true;
      this.openAddedItems = false;
      this.edit = {
        isEdit: true,
        index: i,
      };
      this.showDropdown = null;
    },
    doDeleteItem(i) {
      let temp = [...this.savedItems];
      temp.splice(i, 1);
      this.savedItems = temp;
      this.showDropdown = null;
    },
    handleDropdown(i) {
      if (this.showDropdown === null) {
        this.showDropdown = i;
      } else if (this.showDropdown !== null && this.showDropdown !== i) {
        this.showDropdown = i;
      } else this.showDropdown = null;
    },
  },
  beforeRouteLeave(to, _from, next) {
    if (to.name !== "Records") {
      this.$emit("hideRecords");
    }
    next();
  },
};
</script>

<style scoped>
td {
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
}

th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.dispatch {
  background: #b7c3cd;
  border-radius: 30px;
  border-color: transparent;
}
.wrapper {
  display: flex;
  place-items: center;
  flex-flow: column;
  padding: 7rem;
  position: relative;
}
.btn-absolute {
  position: absolute;
  bottom: 0;
  right: 5%;
}
.wrapper p {
  text-align: center;
}
.wrapper h4 {
  font-weight: 500;
  font-size: 24px;
}
.btn-white {
  border-color: #213e7a;
  background-color: white;
  color: #213e7a;
}
.items {
  border: solid 1px #213e7a;
  margin-top: 10px;
}
.added_items {
  padding: 15px;
}
.items .col-4,
.items p {
  margin-bottom: 0;
}
.summary p {
  margin-bottom: 0;
}
.summary .d-flex.mb-2 div:first-child {
  flex-grow: 0.3;
}
.section-1 {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.section-2 .first {
  flex-grow: 0.5;
}
.first .d-flex p {
  flex-grow: 0.4;
}
.section-2 .item {
  border: solid 1px rgba(0, 0, 0, 0.1);
  padding: 7px;
}
.emails {
  /* overflow-y: auto; */
  /* position: absolute; */
  width: 100%;
  z-index: 100;
  background: white;
  border: solid 1px lightgrey;
}
.devices_ {
  max-height: 6rem;
  overflow-y: scroll;
}
.view-selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.tracking-code {
  display: flex;
  flex-flow: column;
  place-items: center;
  padding: 4rem 1rem 1rem;
}
.tracking-code h1 {
  margin-bottom: 5rem;
}
.item {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.edit-drop {
  position: absolute;
  display: flex;
  flex-flow: column;
  right: 0rem;
  top: 1rem;
  background: #ffffff;
  /* border: 0.3px solid rgba(183, 195, 205, 0.4); */
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
  border-radius: 1px;
  z-index: 2;
}
.edit-drop span {
  padding: 0.5rem 2rem;
  border: 0.3px solid rgba(183, 195, 205, 0.4);
  cursor: pointer;
}
.edit-drop span:hover {
  background-color: rgba(236, 236, 236, 0.33);
}
input.search-input {
  border: 0;
  border-bottom: 1px solid #dadfe2;
  padding-left: 15px;
  padding-bottom: 10px;
}
a:hover {
  text-decoration: underline;
  color: #8693a5;
}

@media (max-width: 576px) {
  .wrapper {
    padding: 4rem;
  }
  /* .items .row {
    display: block !important;
  } */
}
</style>

<i18n>
{
	"en": {
		"addMultipleItemsDelivery": "You can now add multiple Items for delivery",
		"addNewItemButton": "Add New Item",
		"addNewItemTitle": "Add New Item",
		"addressKey": "Address",
		"all_dispatch": "All Dispatch",
		"avg_humid": "Avg. Humidity",
		"avg_temp": "Avg. Temp",
		"backButton": "Back",
		"backKey": "Back",
		"codeSentTo": "*This code will be sent to both customer and admin",
		"customerDetails": "Customer Details",
		"customerDetailsKey": "Customer Details",
		"description": "Description",
		"descriptionItemKey": "Description",
		"descriptionKey": "Description",
		"deviceNoKey": "Device No",
		"devices": "Devices",
		"devicesSelected": "Device(s) Selected",
		"editItem": "Edit Item",
		"emailKey": "Email",
		"generateTrackingCodeKey": "Generate Tracking Code",
		"group_monitor": "Group and monitor a selected cluster of devices in one view, instantly. Create a group to get started.",
		"group_name": "Group Name",
		"itemDescription": "Item Description",
		"itemDetailsKey": "Item Details",
		"itemNameKey": "Name",
		"itemPrice": "Item Price ",
		"itemQuantity": "Item Quantity",
		"itemWeight": "Item Weight (KG)",
		"name": "Name",
		"nameKey": "Name",
		"newItemHeader": "New Item",
		"new_group": "Add New Dispatch",
		"nextButton": "Next",
		"no_dev": "No device added",
		"no_group_yet": "You have no groups yet",
		"no_user": "No user added",
		"num_dev": "Number of Devices",
		"num_users": "Number of Users",
		"phoneKey": "Phone",
		"price": "Price",
		"priceKey": "Price",
		"quantity": "Quantity",
		"quantityKey": "Quantity",
		"removeItem": "Remove Item",
		"saveButton": "Save",
		"searchDevicesPlaceholder": "Search Devices",
		"selectDevicePlaceholder": "-- Select Device --",
		"summaryHeaderKey": "Summary",
		"trackerLink": "Tracker Link:",
		"trackingCode": "Tracking Code",
		"ur_groups": " Your groups will show here when the Admin assigns you to a Group.",
		"weight": "Weight",
		"weightKey": "Weight",
		"whatDelivering": "What are you delivering"
	},
	"es": {
		"addMultipleItemsDelivery": "Ahora puede agregar varios artículos para la entrega",
		"addNewItemButton": "Agregar ítem nuevo",
		"addNewItemTitle": "Agregar ítem nuevo",
		"addressKey": "Dirección",
		"all_dispatch": "Todo Despacho",
		"avg_humid": "Promedio Humedad",
		"avg_temp": "Promedio Temperatura",
		"backButton": "atrás",
		"backKey": "atrás",
		"codeSentTo": "*Este código se enviará tanto al cliente como al administrador",
		"customerDetails": "Detalles del cliente",
		"customerDetailsKey": "Detalles del cliente",
		"description": "Descripción",
		"descriptionItemKey": "Descripción",
		"descriptionKey": "Descripción",
		"deviceNoKey": "Número de dispositivo",
		"devices": "Dispositivos",
		"devicesSelected": "Dispositivo(s) seleccionado(s)",
		"editItem": "Editar elemento",
		"emailKey": "Email",
		"generateTrackingCodeKey": "Generar código de seguimiento",
		"group_monitor": "Agrupe y supervise un grupo seleccionado de dispositivos en una sola vista, al instante. Crea un grupo para empezar.",
		"group_name": "Nombre del grupo",
		"itemDescription": "Descripción del Artículo",
		"itemDetailsKey": "Detalles del artículo",
		"itemNameKey": "Nombre",
		"itemPrice": "Precio del artículo ",
		"itemQuantity": "cantidad de objetos",
		"itemWeight": "Peso del artículo (KG)",
		"name": "Nombre",
		"nameKey": "Nombre",
		"newItemHeader": "Nuevo artículo",
		"new_group": "Agregar nuevo envío",
		"nextButton": "Siguiente",
		"no_dev": "Ningún dispositivo agregado",
		"no_group_yet": "Aún no tienes grupos",
		"no_user": "Ningún usuario agregado",
		"num_dev": "Numero de dispositivos",
		"num_users": "Número de usuarios",
		"phoneKey": "Teléfono",
		"price": "Precio",
		"priceKey": "Precio",
		"quantity": "Cantidad",
		"quantityKey": "Cantidad",
		"removeItem": "Remover el artículo",
		"saveButton": "Salvar",
		"searchDevicesPlaceholder": "Dispositivos de búsqueda",
		"selectDevicePlaceholder": "-- Seleccione el dispositivo --",
		"summaryHeaderKey": "Resumen",
		"trackerLink": "Enlace de seguimiento:",
		"trackingCode": "Codigo de localización",
		"ur_groups": " Tus grupos se mostrarán aquí cuando el administrador te asigne a un grupo.",
		"weight": "Peso",
		"weightKey": "Peso",
		"whatDelivering": "que estas entregando"
	},
	"fr": {
		"addMultipleItemsDelivery": "Vous pouvez maintenant ajouter plusieurs articles pour la livraison",
		"addNewItemButton": "Ajoute un nouvel objet",
		"addNewItemTitle": "Ajoute un nouvel objet",
		"addressKey": "Adresse",
		"all_dispatch": "Toutes les expéditions",
		"avg_humid": "Moyenne. Humidité",
		"avg_temp": "Moy. Temp",
		"backButton": "Retour",
		"backKey": "Retour",
		"codeSentTo": "*Ce code sera envoyé au client et à l'administrateur",
		"customerDetails": "Détails du client",
		"customerDetailsKey": "Détails du client",
		"description": "La description",
		"descriptionItemKey": "La description",
		"descriptionKey": "La description",
		"deviceNoKey": "Appareil Non",
		"devices": "Dispositifs",
		"devicesSelected": "appareil(s) sélectionné(s)",
		"editItem": "Modifier l'article",
		"emailKey": "Email",
		"generateTrackingCodeKey": "Générer un code de suivi",
		"group_monitor": "Regroupez et surveillez un groupe sélectionné d'appareils dans une seule vue, instantanément. Créez un groupe pour commencer.",
		"group_name": "Nom de groupe",
		"itemDescription": "Description de l'article",
		"itemDetailsKey": "Détails de l'article",
		"itemNameKey": "Prénom",
		"itemPrice": "Prix de l'article ",
		"itemQuantity": "Quantité d'article",
		"itemWeight": "Poids de l'article (KG)",
		"name": "Prénom",
		"nameKey": "Prénom",
		"newItemHeader": "Nouvel article",
		"new_group": "Nouveau groupe",
		"nextButton": "Suivant",
		"no_dev": "Aucun appareil ajouté",
		"no_group_yet": "Vous n'avez pas encore de groupes",
		"no_user": "Aucun utilisateur ajouté",
		"num_dev": "Nombre d'appareils",
		"num_users": "Nombre d'utilisateurs",
		"phoneKey": "Téléphone",
		"price": "Prix",
		"priceKey": "Prix",
		"quantity": "Quantité",
		"quantityKey": "Quantité",
		"removeItem": "Retirer l'objet",
		"saveButton": "sauvegarder",
		"searchDevicesPlaceholder": "Rechercher des appareils",
		"selectDevicePlaceholder": "-- Choisir un appareil --",
		"summaryHeaderKey": "Résumé",
		"trackerLink": "Lien de suivi : ",
		"trackingCode": "Code de suivi",
		"ur_groups": "Vos groupes s'afficheront ici lorsque l'administrateur vous affectera à un groupe.",
		"weight": "Poids",
		"weightKey": "Poids",
		"whatDelivering": "Que livrez-vous"
	},
	"sw": {
		"addMultipleItemsDelivery": "Sasa unaweza kuongeza Vipengee vingi kwa ajili ya uwasilishaji",
		"addNewItemButton": "Ongeza Kipengee Kipya",
		"addNewItemTitle": "Ongeza Kipengee Kipya",
		"addressKey": "Anwani",
		"all_dispatch": "Utumaji Wote",
		"avg_humid": "Wastani. Unyevu",
		"avg_temp": "Wastani. Muda",
		"backButton": "Rudi",
		"backKey": "Rudi",
		"codeSentTo": "*Nambari hii itatumwa kwa mteja na msimamizi",
		"customerDetails": "Maelezo ya Wateja",
		"customerDetailsKey": "Maelezo ya Wateja",
		"description": "Maelezo",
		"descriptionItemKey": "Maelezo",
		"descriptionKey": "Maelezo",
		"deviceNoKey": "Kifaa Na",
		"devices": "Vifaa",
		"devicesSelected": "Kifaa Kimechaguliwa",
		"editItem": "Badilisha Kipengee",
		"emailKey": "Barua pepe",
		"generateTrackingCodeKey": "Tengeneza Msimbo wa Ufuatiliaji",
		"group_monitor": "Panga na ufuatilie kundi lililochaguliwa la vifaa katika mwonekano mmoja, papo hapo. Unda kikundi ili uanze.",
		"group_name": "Jina la kikundi",
		"itemDescription": "Maelezo ya Kipengee",
		"itemDetailsKey": "Maelezo ya Kipengee",
		"itemNameKey": "Jina",
		"itemPrice": "Bei ya Bidhaa ",
		"itemQuantity": "Kiasi cha Kipengee",
		"itemWeight": "Uzito wa Bidhaa (KG)",
		"name": "Jina",
		"nameKey": "Jina",
		"newItemHeader": "Kipengee Kipya",
		"new_group": "Ongeza Utumaji Mpya",
		"nextButton": "Ifuatayo",
		"no_dev": "Hakuna kifaa kilichoongezwa",
		"no_group_yet": "Bado huna vikundi",
		"no_user": "Hakuna mtumiaji aliyeongezwa",
		"num_dev": "Idadi ya Vifaa",
		"num_users": "Idadi ya Watumiaji",
		"phoneKey": "Simu",
		"price": "Bei",
		"priceKey": "Bei",
		"quantity": "Kiasi",
		"quantityKey": "Kiasi",
		"removeItem": "Ondoa Kipengee",
		"saveButton": "Okoa",
		"searchDevicesPlaceholder": "Tafuta Vifaa",
		"selectDevicePlaceholder": "-- Chagua Kifaa --",
		"summaryHeaderKey": "Muhtasari",
		"trackerLink": "Kiungo cha Kifuatiliaji:",
		"trackingCode": "Msimbo wa Ufuatiliaji",
		"ur_groups": " Vikundi vyako vitaonekana hapa Msimamizi atakapokukabidhi kwa Kikundi.",
		"weight": "Uzito",
		"weightKey": "Uzito",
		"whatDelivering": "Unaleta nini"
	}
}
</i18n>
